/**
 * @description 事件监听管理器
 * @author TKB
 * @creat 2024-01-02 17:07:00
 */
import { BaseManager } from "./BaseManager";

//放置事件名
const EventManagerCommand = {
  keyDown: "0", // 键盘按下
  keyUp: "1", // 键盘松开
  pointerDown: "2", // 鼠标按下
  pointerUp: "3", // 鼠标松开
  dblClick: "4", // 鼠标双击
  pointerMove: "5", // 鼠标移动
  touchstart: "6", // 触摸
  touchend: "7", // 触摸
  touchcancel: "8", // 触摸
  touchleave: "9", // 触摸
  mouseDrop: "10", // 拖拽
  resize: "11", // 窗口修改大小

  vrFloorCursorLoaded: "12", // vr中地面光标加载完成

  loadManagerInitCompleted: "13", // 加载管理器初始化完成
  sceneManagerInitCompleted: "14", // 场景管理器初始化完成
  modelAllLoaded: "15", // 模型全部加载完成
};

class EventManager extends BaseManager {
  constructor(manager) {
    super(manager);
  }

  init(manager) {
    super.init(manager);

    this.eventsDic = new Map();
  }

  update(dt) {
    super.update(dt);
  }

  clear() {
    this.removeAllEventListenter();

    super.clear();
  }

  /**
   * 增加一个事件监听
   * @param {*} key 事件名
   * @param {*} event 事件
   */
  addEventListener(key, event) {
    //console.log("添加事件", key, event);
    if (!key || !event) {
      console.warn("事件监听增加失败! key=" + key + "  event=" + event);
    }
    if (this.eventsDic.has(key)) {
      this.eventsDic.get(key).push(event);
    } else {
      this.eventsDic.set(key, [event]);
    }
  }

  /**
   * 根据事件名及事件删除单个事件
   * @param {*} key 事件名
   * @param {*} event 事件
   */
  removeEventListener(key, event) {
    if (this.eventsDic.has(key)) {
      let events = this.eventsDic.get(key);
      let index = events.indexOf(event);
      if (index >= 0) events.splice(index, 1);
    }
  }

  /**
   * 根据事件名删除所有事件
   * @param {*} key 事件名
   */
  removeEventListeners(key) {
    if (this.eventsDic.has(key)) {
      this.eventsDic.delete(key);
    }
  }

  /**
   * 清除所有事件
   */
  removeAllEventListenter() {
    if (this.eventsDic) {
      this.eventsDic.clear();
    }
  }

  /**
   * 根据事件名触发事件
   * @param {*} key 事件名
   * @param  {...any} arg 参数列表
   */
  dispach(key, ...arg) {
    if (this.eventsDic.has(key)) {
      const events = this.eventsDic.get(key);
      for (var i = 0; i < events.length; i++) {
        events[i](arg);
      }
    }
  }
}

export { EventManagerCommand, EventManager };
